module.exports = __webpack_public_path__ + "img/noBirthdays.fbc87bb3.svg";